import React from "react";

export default class WebCnContractor extends React.Component {
  render() {
    const { Bs, VARIANT } = this.props;
    return (
      <Bs col xs={12} md={6} lg={6} className="mb-2">
        <Bs row className="mb-2">
          <Bs b>Zhotovitel</Bs>
        </Bs>
        <Bs row>
          <Bs small>(IČO: 25130340)</Bs>
        </Bs>
        <Bs row>
          <Bs small>BRITEX</Bs>
        </Bs>
        <Bs row>
          <Bs small>Milady Horákové 125</Bs>
        </Bs>
        <Bs row>
          <Bs small>Kladno, 27201, CZ</Bs>
        </Bs>
      </Bs>
    );
  }
}
